import { useGlobalStore } from '@/stores/global';

export const assets = (key: string) => {
  const globalStore = useGlobalStore();
  const { dynamic_assets_base_url } = globalStore;
  return `${dynamic_assets_base_url}/${key}`;
};

export const staticAssets = (key: string) => {
  const globalStore = useGlobalStore();
  const { static_assets_base_url } = globalStore;
  return `${static_assets_base_url}/recruiter/img/${key}`;
};
